(function flexible(window, document) {
  const docEl = document.documentElement;
  const dpr = window.devicePixelRatio || 1;

  // 设置data-dpr属性，部分框架可用
  docEl.setAttribute('data-dpr', dpr);

  // 设置viewport meta标签，确保设备宽度适配
  const metaViewport = document.createElement('meta');
  metaViewport.setAttribute('name', 'viewport');
  metaViewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
  document.head.appendChild(metaViewport);

  // 设置rem大小
  function setRem() {
    const designWidth = 375; // 设计稿宽度
    const maxWidth = 1920;   // 最大适配宽度
    let width = docEl.clientWidth;

    if (width > maxWidth) width = maxWidth;

    // 设置1rem = 1/10 屋面宽度（也就是375宽时，1rem=37.5px）
    const rem = (width / designWidth) * 16;
    docEl.style.fontSize = rem + 'px';
  }

  // 强制页面加载后立即执行一次自适应调整
  function initRem() {
    docEl.style.fontSize = '8px'; // 设置初始小字体大小，避免加载时出现错误
    setRem(); // 设置 rem
  }

  // 强制触发浏览器计算并刷新页面布局
  function forceReflow() {
    // 强制设置页面宽度，触发重新计算
    docEl.style.width = '100%';
    // 手动触发resize事件，强制浏览器重新计算
    window.dispatchEvent(new Event('resize'));
  }

  // 页面加载完成时进行自适应调整
  window.addEventListener('load', function () {
    setTimeout(function () {
      initRem(); // 初始化rem
      forceReflow(); // 强制刷新布局
    }, 500); // 延迟500ms执行，确保页面加载完成
  });

  // 页面 DOMContentLoaded 完成后再执行一次 rem 适配
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      initRem(); // 初始化rem
      forceReflow(); // 强制刷新布局
    }, 500); // 延迟500ms执行，确保DOM完全加载
  });

  // 使用requestAnimationFrame进行优化，确保在页面渲染完成后再执行 rem 设置
  function optimizedSetRem() {
    requestAnimationFrame(function () {
      setRem(); // 使用requestAnimationFrame确保页面渲染完成后再调整
    });
  }

  // 定期检测页面尺寸并刷新
  let checkInterval;
  function startCheck() {
    checkInterval = setInterval(function () {
      const currentWidth = docEl.clientWidth;
      // 检查宽度是否发生变化
      if (currentWidth !== docEl.getBoundingClientRect().width) {
        optimizedSetRem(); // 重新计算rem并更新
        forceReflow(); // 强制刷新页面布局
      }
    }, 500); // 每500ms检查一次页面大小
  }

  // 停止定时器
  function stopCheck() {
    if (checkInterval) {
      clearInterval(checkInterval);
    }
  }

  // 启动定期检测
  startCheck();

  // 页面 DOMContentLoaded 完成后再执行一次 rem 适配
  document.addEventListener('DOMContentLoaded', function () {
    optimizedSetRem(); // 使用requestAnimationFrame确保页面渲染完成后再调整
    stopCheck(); // 完成检测后停止检查
  });

  // 监听 resize 和 orientationchange 事件
  window.addEventListener('resize', function () {
    optimizedSetRem(); // 在屏幕尺寸变化时调整
  });

  window.addEventListener('orientationchange', function () {
    optimizedSetRem(); // 在设备方向变化时调整
  });
})(window, document);
